import { ActionCreator } from "redux";
import {
  GET_PATIENT_APPOINTMENTS,
  POST_CONFIRM_APPOINTMENT
} from "./constant";
import {
  GetPatientAppointmentsFromServerAction,
  PostConfirmAppointmentToServerAction
} from "./types";

export const getPatientAppointmentsFromServer: ActionCreator<GetPatientAppointmentsFromServerAction> = (patientId: string) => ({
    type: GET_PATIENT_APPOINTMENTS,
    payload: {
        patientId
    },
});

export const postConfirmAppointmentToServer: ActionCreator<PostConfirmAppointmentToServerAction> = (appointmentId: string[]) => ({
    type: POST_CONFIRM_APPOINTMENT,
    payload: {
        appointmentId
    }
});



// WEBPACK FOOTER //
// ./src/sagas/Appointments/actions.ts